/*
 * Module for the PROP Distribution Option step of the PROP Deferral and Distribution form
*/
rs.module("ui/content/communications/onlineforms/propdistributionoption",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var distributionOptionRadio = stepContainer.js(jsSelectors.distributionOptionRadio, { multiple: true });
            var distributionOptionDescriptionDiv = stepContainer.js(jsSelectors.distributionOptionDescriptionDiv, { multiple: true });
            var partialPaymentAmount = stepContainer.js(jsSelectors.partialPaymentAmount);
            var withholdingOptionRadio = $.js(jsSelectors.withholdingOptionRadio, { multiple: true });
            var withholdingOptionDescriptionDiv = $.js(jsSelectors.withholdingOptionDescriptionDiv, { multiple: true });

            // Evaluate distribution option checked
            var selected = distributionOptionRadio.filter(":checked");
            var selectedIndex = distributionOptionRadio.index(selected);
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedPROPDistributionOptionDescription(selectedIndex);
            }

            // Evaluate withholding option checked
            var selectedWithholding = withholdingOptionRadio.filter(":checked");
            var selectedWithholdingIndex = withholdingOptionRadio.index(selectedWithholding);
            if (selectedWithholdingIndex !== null && selectedWithholdingIndex >= 0) {
                showSelectedWithholdingOptionDescription(selectedWithholdingIndex);
            }

            // Handle the distributionOptionRadio click event
            distributionOptionRadio.on("click", function () {

                // Clear partial payment amount and errors
                partialPaymentAmount.val('');
                partialPaymentAmount.clearErrors();

                var selectedIndex = distributionOptionRadio.index(this);
                showSelectedPROPDistributionOptionDescription(selectedIndex);
            });

            // Handle the withholdingOptionRadio click event
            withholdingOptionRadio.on("click", function () {

                var selectedIndex = withholdingOptionRadio.index(this);
                showSelectedWithholdingOptionDescription(selectedIndex);
            });

            // Show (slide down) the description for the selected prop distribution option
            function showSelectedPROPDistributionOptionDescription(selectedIndex) {

                // Close all quickly
                distributionOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                distributionOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }

            // Show (slide down) the description for the selected withholding option
            function showSelectedWithholdingOptionDescription(selectedIndex) {

                // Close all quickly
                withholdingOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                withholdingOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);